import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPurchase = () => import('./staff/purchase')
const ViewStaffCurrentsAccounts = () => import('./staff/currentsAccounts')
const ViewStaffReports = () => import('./staff/reports')
const ViewStaffPurchaseCategory = () => import('./staff/purchaseCategory')
const ViewStaffPurchaseInfoPayment = () => import('./staff/purchaseInfoPayment')

Vue.use(Router)

const router =
  [
    {
      path: '/st/purchase',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'PurchaseStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Compras',
          }          
        },
        {
          path: 'purchase',
          name: 'PurchaseStaffPurchase',
          component: ViewStaffPurchase,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Comprobantes de compras',
          }          
        },
        {
          path: 'purchase/generate/remits/:remitsID',
          name: 'PurchaseStaffPurchaseGenerateByRemits',
          component: ViewStaffPurchase,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Compras desde remitos',
          }          
        },
        {
          path: 'CurrentsAccounts',
          name: 'PurchaseStaffCurrentsAccounts',
          component: ViewStaffCurrentsAccounts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cuenta corriente de proveedores',
          }          
        },
        {
          path: 'reports',
          name: 'PurchaseStaffReports',
          component: ViewStaffReports,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes de compras',
          }          
        },
        {
          path: 'purchaseCategory',
          name: 'PurchaseStaffPurchaseCategory',
          component: ViewStaffPurchaseCategory,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM de categorias de compras',
          }          
        },      
        {
          path: 'purchaseInfoPayment',
          name: 'PurchaseStaffPurchaseInfoPayment',
          component: ViewStaffPurchaseInfoPayment,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM de formas de pago en compras',
          }          
        },                
      ]
    },

    {
      path: '/cu/purchase',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/purchase',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
